import { NavItem, NavItemAccessor, Tag, Text } from '@billy/design-system'
import { TFunction } from 'i18next'

import { Contact } from '@features/contacts/types/contact'

import * as Styled from '../styles'
import { ContactValue } from '../types/contactValue'

const SUGGESTIONS_HEADER_ID = 'new-suppliers-suggestions-header'

export const getItems = (
  contacts: Contact[],
  t: TFunction,
  isPagesLimitItem?: boolean,
  newSupplierSuggestions?: Partial<Contact>[],
): NavItem<ContactValue>[] => {
  const items: NavItem<ContactValue>[] = []
  const hasSuggestions = !!newSupplierSuggestions && newSupplierSuggestions.length > 1

  if (hasSuggestions) {
    items.push({
      id: SUGGESTIONS_HEADER_ID,
      accessor: NavItemAccessor.Header,
      children: t('contact_select.suggestions_header.text'),
      value: {} as ContactValue,
    })

    for (const [index, suggestion] of newSupplierSuggestions.entries()) {
      const displayTitle = suggestion.name
      const registrationNumber = suggestion.registrationNo || suggestion.vatNo
      const address = [suggestion.street, [suggestion.zipcodeText, suggestion.cityText].filter(Boolean).join(' ')]
        .filter(Boolean)
        .join(', ')
      const description = [registrationNumber, address || undefined].filter((value): value is string => !!value)

      items.push({
        id: `new-supplier-suggestion-${index}`,
        accessorGroupId: SUGGESTIONS_HEADER_ID,
        children: displayTitle,
        value: {
          ...suggestion,
          displayData: {
            title: displayTitle,
            description: description.length ? description : undefined,
            suffix: (
              <Tag color="blue" size="sm" type="subtle">
                {t('contact_select.new_contact_tag.text')}
              </Tag>
            ),
          },
        },
      })
    }
    return items
  }

  for (const contact of contacts) {
    const displayTitle = contact.name
    const searchKeywords = [contact.id, displayTitle]

    items.push({
      id: contact.id,
      children: displayTitle,
      searchKeywords,
      value: {
        ...contact,
        displayData: {
          title: displayTitle,
        },
      },
    })
  }

  if (isPagesLimitItem) {
    items.push({
      accessor: NavItemAccessor.Unselectable,
      id: NavItemAccessor.Unselectable,
      children: t('contact_select.footer.pages_limit'),
      readonly: true,
      value: {
        displayData: {
          title: (
            <Styled.DropdownPagesLimit>
              <Text colorVariant="placeholder" alignment="center">
                {t('contact_select.footer.pages_limit')}
              </Text>
            </Styled.DropdownPagesLimit>
          ),
        },
      } as ContactValue,
    })
  }

  return items
}
